import { render } from "./DashboardCards.vue?vue&type=template&id=1a219dee&ts=true"
import script from "./DashboardCards.vue?vue&type=script&lang=ts"
export * from "./DashboardCards.vue?vue&type=script&lang=ts"

import "./DashboardCards.vue?vue&type=style&index=0&id=1a219dee&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__